module.exports = __webpack_public_path__ + "static/media/26.7abbb3df.mp3";